import { render, staticRenderFns } from "./HistoryNavigation.vue?vue&type=template&id=4b77f71e&"
import script from "./HistoryNavigation.vue?vue&type=script&lang=js&"
export * from "./HistoryNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports